// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE_SPACE } from "./action";

export function canCreateSpace(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE_SPACE);
}
